import React from 'react';
import { Button, Table, Modal, Input, Grid, Form, TextArea, Dropdown, Image } from 'semantic-ui-react';
import $ from "jquery";

import Loading from '../../loading';
import Server from '../../../functions/server';
import Adds from '../../media/add.png';

class Model extends React.Component {

  state = {
    status: 1, modelName: '', tamilName: '', priority: '', description: '', file: '', file1: Adds
  }

  status = (f, { value }) => { this.setState({ status: value }) }

  onChangeText = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  convertToNumber(value) {
    value = Number(value);
    return value;
  }

  editModel() {
    this.setState({
      modelName: this.props.item.model_name,
      tamilName: this.props.item.tamil_name,
      description: this.props.item.description,
      file1: this.props.item.image,
      status: this.convertToNumber(this.props.item.status),
      priority: this.props.item.priority,
      open: true
    })
  }

  updateImage(image) {
    let context = this;
    var formData = new FormData();
    formData.append('image', image);
    formData.append('id', this.props.item.id);
    context.setState({ load: true, message: 'Update Image' })
    $.ajax({
      type: 'POST', processData: false,
      contentType: false, data: formData,
      url: Server() + 'machinemodel/updateimage.php',
      success: function(data) {
        if (data == 1) {
          alert('Image Changed Successfully');
          context.setState({ load: false });
        }
        else {
          context.setState({ load: false });
        }
      },
      error: function(error) {
        console.log(error);
      }
    });
  }

  updateLocalfile(value) {
    if (this.props.title != 'Add Model') {
      this.updateImage(value);
    }
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({ file1: out });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  updateData() {
    let context = this;
    let data = { modelName: this.state.modelName, tamilName: this.state.tamilName, priority: this.state.priority,
                 description: this.state.description, status: this.state.status, id: this.props.item.id };
    this.setState({ load: true, message: 'Update Model!!!' })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'machinemodel/update.php',
      success: function(data) {
        if (data == 1) {
          alert('Success');
          let models = context.props.models;
          models.map((c) => {
            if (c.id == context.props.item.id) {
              c.model_name = context.state.modelName;
              c.tamil_name = context.state.tamilName;
              c.description = context.state.description;
              c.status = context.state.status;
              c.priority = context.state.priority;
            }
          })
          context.props.updateModels(models);
          context.setState({ load: false, open: false, modelName: '', tamilName: '', priority: '', description: '' });
        }
        else {
          alert('Error');
          context.setState({ load: false })
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  addModel() {
    let context = this;
    if (!this.state.modelName) { alert('Enter Model Name!!!'); return; }
    if (!this.state.tamilName) { alert('Enter Tamil Name!!!'); return; }
    if (!this.state.priority) { alert('Enter Priority!!!'); return; }
    if (!this.state.description) { alert('Enter Description!!!'); return; }
    if (!this.state.file) { alert('Select Image!!!'); return; }
    var formData = new FormData();
    formData.append('modelName', this.state.modelName);
    formData.append('tamilName', this.state.tamilName);
    formData.append('priority', this.state.priority);
    formData.append('description', this.state.description);
    formData.append('status', this.state.status);
    formData.append('file', this.state.file);
    context.setState({ load: true, message: 'Add Model' })
    $.ajax({
      type: 'POST', processData: false,
      contentType: false, data: formData,
      url: Server() + 'machinemodel/addmodel.php',
      success: function(data) {
        console.log(data);
        if (data == 1) {
          context.setState({ open: false, file: '', file1: '', modelName: '', tamilName: '', priority: '', description: '', load: false });
          context.props.machineModel();
        }
        else {
          context.setState({ load: false });
        }
      },
      error: function(error) {
        console.log(error);
      }
    });
  }

  render() {
    let modelOption = [
      {key: 'Active', text: 'Active', value: 1},
      {key: 'InActive', text: 'InActive', value: 0}
    ];
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        { this.props.title == 'Add Model' ?
          (<div><Button primary onClick={ () => { this.setState({ open: true }) }}>Add Model</Button><br/><br/></div>):
          (<div style={{cursor: 'pointer', color: 'blue'}} onClick={this.editModel.bind(this)}><u>Edit</u></div>)
        }
        <Modal open={this.state.open} onClose={ () => { this.setState({ open: false }) }}>
          <Modal.Header>{'Add Model'}</Modal.Header>
          <Modal.Content>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={11}>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Model Name
                    <Input fluid onChange={this.onChangeText('modelName')} value={this.state.modelName} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Tamil Name
                    <Input fluid onChange={this.onChangeText('tamilName')} value={this.state.tamilName} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Status
                    <Dropdown style={{ borderColor: '#5A9CBB' }} fluid selection onChange={this.status}
                     options={modelOption} value={this.state.status} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Priority
                    <Input type='number' fluid onChange={this.onChangeText('priority')} value={this.state.priority} />
                  </Grid.Column>
                </Grid>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                <b>Select Image</b>
                <input id={'1'} type="file" onChange={(e) => { this.updateLocalfile(e.target.files[0]);
                  this.setState({file: e.target.files[0]});}} style={{display: 'none'}}/>
                <label htmlFor={'1'}>
                  <Image src={this.state.file1} size='small'
                  style={{width: '100%', height: '150px', cursor: 'pointer'}}
                  id='image' />
                </label>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Description
                <Form>
                  <TextArea fluid placeholder='Description'  onChange={this.onChangeText('description')} value={this.state.description} />
                </Form>
              </Grid.Column>
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={ () => { this.setState({ open: false }) }} negative>
              Cancel
            </Button>
            { this.props.title == 'Add Model' ?
              (<Button onClick={this.addModel.bind(this)} positive labelPosition='right' icon='checkmark' content='Yes' />):
              (<Button onClick={this.updateData.bind(this)} positive labelPosition='right' icon='checkmark' content='Yes' />)
            }
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default Model;
